import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    sessionId: String,
    pagePath: String,
    pageTitle: String,
    referrer: String,
    userId: String
  }

  connect() {
    setTimeout(() => {
      this.trackPageView()
    }, 100)
  }

  trackPageView() {
    const startTime = Date.now()
    
    window.addEventListener('beforeunload', () => {
      this.sendAnalytics(startTime)
    })

    setTimeout(() => {
      this.sendAnalytics(startTime)
    }, 10000)
  }

  sendAnalytics(startTime) {
    const endTime = Date.now()
    const duration = Math.round((endTime - startTime) / 1000)

    const data = {
      session_id: this.sessionIdValue || this.generateSessionId(),
      page_path: this.pagePathValue || window.location.pathname,
      page_title: this.pageTitleValue || document.title,
      referrer: this.referrerValue || document.referrer,
      user_id: this.userIdValue || null,
      ip_address: null, // Will be detected server-side
      user_agent: navigator.userAgent,
      visit_start: new Date(startTime).toISOString(),
      visit_end: new Date(endTime).toISOString(),
      duration_seconds: duration,
      language: navigator.language,
      screen_resolution: `${screen.width}x${screen.height}`,
      device_type: this.getDeviceType(),
      browser: this.getBrowser(),
      os: this.getOS()
    }

    // Send analytics data asynchronously
    fetch('/api/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ analytics: data }),
      keepalive: true // Ensure request completes even if page is unloading
    }).catch(() => {})
  }

  generateSessionId() {
    let sessionId = sessionStorage.getItem('analytics_session_id')
    if (!sessionId) {
      sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
      sessionStorage.setItem('analytics_session_id', sessionId)
    }
    return sessionId
  }

  getDeviceType() {
    const width = window.innerWidth
    if (width <= 768) return 'Mobile'
    if (width <= 1024) return 'Tablet'
    return 'Desktop'
  }

  getBrowser() {
    const ua = navigator.userAgent
    if (ua.includes('Chrome')) return 'Chrome'
    if (ua.includes('Firefox')) return 'Firefox'
    if (ua.includes('Safari')) return 'Safari'
    if (ua.includes('Edge')) return 'Edge'
    return 'Unknown'
  }

  getOS() {
    const ua = navigator.userAgent
    if (ua.includes('Windows')) return 'Windows'
    if (ua.includes('Mac')) return 'macOS'
    if (ua.includes('Linux')) return 'Linux'
    if (ua.includes('Android')) return 'Android'
    if (ua.includes('iOS')) return 'iOS'
    return 'Unknown'
  }
}